import { createFileRoute } from '@tanstack/react-router';
import { TenantIpWhitelistForm } from '@/components/tenants/TenantIpWhitelistForm';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/ip-whitelist')({
  component: TenantIpWhitelistRoute,
});

function TenantIpWhitelistRoute() {
  const { tenantCode } = Route.useParams();

  return (
    <div className="space-y-4">
      <div className="text-sm text-muted-foreground">
        Manage the Pick&apos;em IP whitelist for <span className="font-semibold">{tenantCode}</span>
        .
      </div>
      <TenantIpWhitelistForm tenantCode={tenantCode} />
    </div>
  );
}
